import { useSelector } from 'react-redux';
import {
  getWorkspaceById,
  isThereOnlyOneWorkspace,
} from '../../store/selectors/workspace.selector';
import { toSourceName } from './doc-answer';
import type { AnswerSourceItem } from './doc-answer';

/**
 * "Title (Workspace)" for a resolved source item, as the answer card and related rows show it.
 * The workspace shows only for orgs with several, and never for a hub item
 * (cross-org, so the caller's workspace list says nothing about it).
 *
 * @param knowledgeItem - The resolved source item; null or undefined while it is still loading.
 * @param isHub - True for a hub source item. Defaults to false.
 * @returns The source line, or '' until the item resolves.
 *
 * @example
 * const title = useSourceName(knowledgeItem) || resource.title;
 */
export function useSourceName(
  knowledgeItem: AnswerSourceItem | null | undefined,
  isHub = false,
): string {
  const workspace = useSelector(getWorkspaceById(isHub ? undefined : knowledgeItem?.workspaceId));
  const isOnlyOneWorkspace = useSelector(isThereOnlyOneWorkspace);
  if (!knowledgeItem) return '';
  return toSourceName(knowledgeItem, isOnlyOneWorkspace ? null : workspace?.name);
}
